export const genericUploadError = {
  type: '',
  errorType: 'Error',
  errorMessages: ['Could not upload file. Please try again.'],
};

export const convertBToMB = bytes => bytes / 1048576;
